// Norske fylker og byer - oppdatert til 2024 fylkestruktur
// Basert på offisiell by-liste fra Norge

export const FYLKER_MED_BYER = [
  {
    id: 'oslo',
    name: 'Oslo',
    byer: [
      { id: 'oslo', name: 'Oslo' }
    ]
  },
  {
    id: 'akershus',
    name: 'Akershus',
    byer: [
      { id: 'lillestrom', name: 'Lillestrøm' },
      { id: 'sandvika', name: 'Sandvika' },
      { id: 'ski', name: 'Ski' },
      { id: 'jessheim', name: 'Jessheim' },
      { id: 'drobak', name: 'Drøbak' }
    ]
  },
  {
    id: 'buskerud',
    name: 'Buskerud',
    byer: [
      { id: 'drammen', name: 'Drammen' },
      { id: 'kongsberg', name: 'Kongsberg' },
      { id: 'honefoss', name: 'Hønefoss' },
      { id: 'hokksund', name: 'Hokksund' }
    ]
  },
  {
    id: 'ostfold',
    name: 'Østfold',
    byer: [
      { id: 'fredrikstad', name: 'Fredrikstad' },
      { id: 'sarpsborg', name: 'Sarpsborg' },
      { id: 'halden', name: 'Halden' },
      { id: 'moss', name: 'Moss' },
      { id: 'askim', name: 'Askim' },
      { id: 'mysen', name: 'Mysen' }
    ]
  },
  {
    id: 'vestfold',
    name: 'Vestfold',
    byer: [
      { id: 'tonsberg', name: 'Tønsberg' },
      { id: 'sandefjord', name: 'Sandefjord' },
      { id: 'larvik', name: 'Larvik' },
      { id: 'horten', name: 'Horten' },
      { id: 'holmestrand', name: 'Holmestrand' },
      { id: 'stavern', name: 'Stavern' },
      { id: 'asgardstrand', name: 'Åsgårdstrand' }
    ]
  },
  {
    id: 'telemark',
    name: 'Telemark',
    byer: [
      { id: 'skien', name: 'Skien' },
      { id: 'porsgrunn', name: 'Porsgrunn' },
      { id: 'notodden', name: 'Notodden' },
      { id: 'kragero', name: 'Kragerø' },
      { id: 'brevik', name: 'Brevik' },
      { id: 'langesund', name: 'Langesund' },
      { id: 'stathelle', name: 'Stathelle' },
      { id: 'rjukan', name: 'Rjukan' }
    ]
  },
  {
    id: 'agder',
    name: 'Agder',
    byer: [
      { id: 'kristiansand', name: 'Kristiansand' },
      { id: 'arendal', name: 'Arendal' },
      { id: 'grimstad', name: 'Grimstad' },
      { id: 'mandal', name: 'Mandal' },
      { id: 'farsund', name: 'Farsund' },
      { id: 'flekkefjord', name: 'Flekkefjord' },
      { id: 'lillesand', name: 'Lillesand' },
      { id: 'risor', name: 'Risør' },
      { id: 'tvedestrand', name: 'Tvedestrand' },
      { id: 'lyngdal', name: 'Lyngdal' }
    ]
  },
  {
    id: 'rogaland',
    name: 'Rogaland',
    byer: [
      { id: 'stavanger', name: 'Stavanger' },
      { id: 'sandnes', name: 'Sandnes' },
      { id: 'haugesund', name: 'Haugesund' },
      { id: 'egersund', name: 'Egersund' },
      { id: 'bryne', name: 'Bryne' },
      { id: 'kopervik', name: 'Kopervik' },
      { id: 'skudeneshavn', name: 'Skudeneshavn' },
      { id: 'jorpeland', name: 'Jørpeland' },
      { id: 'sauda', name: 'Sauda' },
      { id: 'akrehamn', name: 'Åkrehamn' }
    ]
  },
  {
    id: 'vestland',
    name: 'Vestland',
    byer: [
      { id: 'bergen', name: 'Bergen' },
      { id: 'floro', name: 'Florø' },
      { id: 'forde', name: 'Førde' },
      { id: 'stord', name: 'Stord' },
      { id: 'odda', name: 'Odda' },
      { id: 'maloy', name: 'Måløy' }
    ]
  },
  {
    id: 'more-og-romsdal',
    name: 'Møre og Romsdal',
    byer: [
      { id: 'alesund', name: 'Ålesund' },
      { id: 'molde', name: 'Molde' },
      { id: 'kristiansund', name: 'Kristiansund' },
      { id: 'andalsnes', name: 'Åndalsnes' },
      { id: 'ulsteinvik', name: 'Ulsteinvik' },
      { id: 'fosnavag', name: 'Fosnavåg' }
    ]
  },
  {
    id: 'trondelag',
    name: 'Trøndelag',
    byer: [
      { id: 'trondheim', name: 'Trondheim' },
      { id: 'steinkjer', name: 'Steinkjer' },
      { id: 'namsos', name: 'Namsos' },
      { id: 'levanger', name: 'Levanger' },
      { id: 'roros', name: 'Røros' },
      { id: 'stjordalshalsen', name: 'Stjørdalshalsen' },
      { id: 'verdalsora', name: 'Verdalsøra' },
      { id: 'orkanger', name: 'Orkanger' },
      { id: 'brekstad', name: 'Brekstad' },
      { id: 'kolvereid', name: 'Kolvereid' },
      { id: 'rorvik', name: 'Rørvik' }
    ]
  },
  {
    id: 'nordland',
    name: 'Nordland',
    byer: [
      { id: 'bodo', name: 'Bodø' },
      { id: 'narvik', name: 'Narvik' },
      { id: 'mo-i-rana', name: 'Mo i Rana' },
      { id: 'mosjoen', name: 'Mosjøen' },
      { id: 'bronnoysund', name: 'Brønnøysund' },
      { id: 'svolvar', name: 'Svolvær' },
      { id: 'sortland', name: 'Sortland' },
      { id: 'leknes', name: 'Leknes' },
      { id: 'fauske', name: 'Fauske' },
      { id: 'sandnessjoen', name: 'Sandnessjøen' },
      { id: 'stokmarknes', name: 'Stokmarknes' }
    ]
  },
  {
    id: 'troms',
    name: 'Troms',
    byer: [
      { id: 'tromso', name: 'Tromsø' },
      { id: 'harstad', name: 'Harstad' },
      { id: 'finnsnes', name: 'Finnsnes' },
      { id: 'bardufoss', name: 'Bardufoss' }
    ]
  },
  {
    id: 'finnmark',
    name: 'Finnmark',
    byer: [
      { id: 'hammerfest', name: 'Hammerfest' },
      { id: 'alta', name: 'Alta' },
      { id: 'vadso', name: 'Vadsø' },
      { id: 'vardo', name: 'Vardø' },
      { id: 'kirkenes', name: 'Kirkenes' },
      { id: 'honningsvag', name: 'Honningsvåg' }
    ]
  },
  {
    id: 'innlandet',
    name: 'Innlandet',
    byer: [
      { id: 'hamar', name: 'Hamar' },
      { id: 'lillehammer', name: 'Lillehammer' },
      { id: 'gjovik', name: 'Gjøvik' },
      { id: 'elverum', name: 'Elverum' },
      { id: 'kongsvinger', name: 'Kongsvinger' },
      { id: 'brumunddal', name: 'Brumunddal' },
      { id: 'moelv', name: 'Moelv' },
      { id: 'fagernes', name: 'Fagernes' },
      { id: 'otta', name: 'Otta' },
      { id: 'vinstra', name: 'Vinstra' },
      { id: 'tynset', name: 'Tynset' },
      { id: 'raufoss', name: 'Raufoss' }
    ]
  }
];

// Flatt array med alle fylker (for bakoverkompatibilitet)
export const FYLKER = FYLKER_MED_BYER.map(f => ({ id: f.id, name: f.name }));

// Hjelpefunksjoner
export const getFylkeById = (id) => FYLKER_MED_BYER.find(f => f.id === id);
export const getByerForFylke = (fylkeId) => getFylkeById(fylkeId)?.byer || [];
export const getByById = (byId) => {
  for (const fylke of FYLKER_MED_BYER) {
    const by = fylke.byer.find(b => b.id === byId);
    if (by) return { ...by, fylke: fylke };
  }
  return null;
};

export const getFylkeName = (id) => FYLKER_MED_BYER.find(f => f.id === id)?.name || id;
export const getByName = (id) => {
  for (const fylke of FYLKER_MED_BYER) {
    const by = fylke.byer.find(b => b.id === id);
    if (by) return by.name;
  }
  return id;
};

// Koordinater for by-deteksjon fra GPS/IP
const BY_KOORDINATER = [
  // Oslo-området
  { id: 'oslo', fylkeId: 'oslo', lat: 59.9139, lon: 10.7522 },
  { id: 'lillestrom', fylkeId: 'akershus', lat: 59.9550, lon: 11.0493 },
  { id: 'sandvika', fylkeId: 'akershus', lat: 59.8892, lon: 10.5264 },
  { id: 'ski', fylkeId: 'akershus', lat: 59.7195, lon: 10.8370 },
  { id: 'jessheim', fylkeId: 'akershus', lat: 60.1443, lon: 11.1748 },
  { id: 'drobak', fylkeId: 'akershus', lat: 59.6609, lon: 10.6306 },
  
  // Buskerud
  { id: 'drammen', fylkeId: 'buskerud', lat: 59.7440, lon: 10.2045 },
  { id: 'kongsberg', fylkeId: 'buskerud', lat: 59.6630, lon: 9.6496 },
  { id: 'honefoss', fylkeId: 'buskerud', lat: 60.1676, lon: 10.2563 },
  { id: 'hokksund', fylkeId: 'buskerud', lat: 59.7669, lon: 9.9145 },
  
  // Østfold
  { id: 'fredrikstad', fylkeId: 'ostfold', lat: 59.2181, lon: 10.9298 },
  { id: 'sarpsborg', fylkeId: 'ostfold', lat: 59.2839, lon: 11.1098 },
  { id: 'halden', fylkeId: 'ostfold', lat: 59.1227, lon: 11.3875 },
  { id: 'moss', fylkeId: 'ostfold', lat: 59.4340, lon: 10.6590 },
  
  // Vestfold
  { id: 'tonsberg', fylkeId: 'vestfold', lat: 59.2675, lon: 10.4076 },
  { id: 'sandefjord', fylkeId: 'vestfold', lat: 59.1314, lon: 10.2165 },
  { id: 'larvik', fylkeId: 'vestfold', lat: 59.0539, lon: 10.0269 },
  { id: 'horten', fylkeId: 'vestfold', lat: 59.4171, lon: 10.4851 },
  
  // Telemark
  { id: 'skien', fylkeId: 'telemark', lat: 59.2099, lon: 9.6099 },
  { id: 'porsgrunn', fylkeId: 'telemark', lat: 59.1405, lon: 9.6562 },
  { id: 'notodden', fylkeId: 'telemark', lat: 59.5636, lon: 9.2631 },
  
  // Agder
  { id: 'kristiansand', fylkeId: 'agder', lat: 58.1599, lon: 8.0182 },
  { id: 'arendal', fylkeId: 'agder', lat: 58.4615, lon: 8.7726 },
  { id: 'grimstad', fylkeId: 'agder', lat: 58.3405, lon: 8.5935 },
  { id: 'mandal', fylkeId: 'agder', lat: 58.0294, lon: 7.4608 },
  
  // Rogaland
  { id: 'stavanger', fylkeId: 'rogaland', lat: 58.9700, lon: 5.7331 },
  { id: 'sandnes', fylkeId: 'rogaland', lat: 58.8524, lon: 5.7352 },
  { id: 'haugesund', fylkeId: 'rogaland', lat: 59.4138, lon: 5.2680 },
  
  // Vestland
  { id: 'bergen', fylkeId: 'vestland', lat: 60.3913, lon: 5.3221 },
  { id: 'forde', fylkeId: 'vestland', lat: 61.4520, lon: 5.8572 },
  { id: 'stord', fylkeId: 'vestland', lat: 59.7790, lon: 5.4924 },
  
  // Møre og Romsdal
  { id: 'alesund', fylkeId: 'more-og-romsdal', lat: 62.4722, lon: 6.1495 },
  { id: 'molde', fylkeId: 'more-og-romsdal', lat: 62.7375, lon: 7.1591 },
  { id: 'kristiansund', fylkeId: 'more-og-romsdal', lat: 63.1103, lon: 7.7280 },
  
  // Trøndelag
  { id: 'trondheim', fylkeId: 'trondelag', lat: 63.4305, lon: 10.3951 },
  { id: 'steinkjer', fylkeId: 'trondelag', lat: 64.0150, lon: 11.4953 },
  { id: 'levanger', fylkeId: 'trondelag', lat: 63.7464, lon: 11.2996 },
  
  // Nordland
  { id: 'bodo', fylkeId: 'nordland', lat: 67.2804, lon: 14.4049 },
  { id: 'narvik', fylkeId: 'nordland', lat: 68.4385, lon: 17.4273 },
  { id: 'mo-i-rana', fylkeId: 'nordland', lat: 66.3128, lon: 14.1427 },
  
  // Troms
  { id: 'tromso', fylkeId: 'troms', lat: 69.6496, lon: 18.9560 },
  { id: 'harstad', fylkeId: 'troms', lat: 68.7984, lon: 16.5417 },
  { id: 'finnsnes', fylkeId: 'troms', lat: 69.2341, lon: 17.9831 },
  
  // Finnmark
  { id: 'hammerfest', fylkeId: 'finnmark', lat: 70.6634, lon: 23.6821 },
  { id: 'alta', fylkeId: 'finnmark', lat: 69.9689, lon: 23.2716 },
  { id: 'kirkenes', fylkeId: 'finnmark', lat: 69.7271, lon: 30.0459 },
  
  // Innlandet
  { id: 'hamar', fylkeId: 'innlandet', lat: 60.7945, lon: 11.0680 },
  { id: 'lillehammer', fylkeId: 'innlandet', lat: 61.1152, lon: 10.4662 },
  { id: 'gjovik', fylkeId: 'innlandet', lat: 60.7957, lon: 10.6916 },
  { id: 'elverum', fylkeId: 'innlandet', lat: 60.8807, lon: 11.5617 },
  { id: 'kongsvinger', fylkeId: 'innlandet', lat: 60.1902, lon: 12.0003 }
];

// Finn nærmeste by basert på koordinater
export const getByFromCoords = (lat, lon) => {
  let closestBy = null;
  let minDistance = Infinity;

  BY_KOORDINATER.forEach(by => {
    const distance = Math.sqrt(
      Math.pow(lat - by.lat, 2) + Math.pow(lon - by.lon, 2)
    );
    if (distance < minDistance) {
      minDistance = distance;
      closestBy = by;
    }
  });

  return closestBy ? { byId: closestBy.id, fylkeId: closestBy.fylkeId } : null;
};

// Finn nærmeste fylke basert på koordinater (fallback)
export const getFylkeFromCoords = (lat, lon) => {
  const result = getByFromCoords(lat, lon);
  return result?.fylkeId || 'oslo';
};
